import { useEffect, useRef } from "react";
import { Box, Button } from "react-bulma-components";
import ConnectionData from "../../js/connection/ConnectionData";
import styles from "../../styles/thumbnailpanel.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

type Props = {
    connections: ConnectionData[];
    isMobileView: boolean;
    onClose: () => void;
};

export default function ThumbnailPanel({ connections, isMobileView, onClose }: Props) {
    const thumbnailRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

    useEffect(() => {
        // Create clean video thumbnails for each connection
        connections.forEach((connection) => {
            const thumbnailContainer = thumbnailRefs.current[connection.id];
            if (!thumbnailContainer || !connection.view) return;

            // Clear any existing content
            thumbnailContainer.innerHTML = '';

            // Find the video element in the connection view
            const sourceVideo = connection.view.querySelector('video');
            if (!sourceVideo) return;

            // Create a new video element for the thumbnail
            const thumbnailVideo = document.createElement('video');
            thumbnailVideo.srcObject = sourceVideo.srcObject;
            thumbnailVideo.autoplay = true;
            thumbnailVideo.muted = true;
            thumbnailVideo.playsInline = true;
            thumbnailVideo.style.width = '100%';
            thumbnailVideo.style.height = '100%';
            thumbnailVideo.style.objectFit = 'cover';
            thumbnailVideo.style.borderRadius = '8px';
            thumbnailVideo.style.transform = 'scaleX(-1)';

            // Add the video to the thumbnail container
            thumbnailContainer.appendChild(thumbnailVideo);
        });
    }, [connections]);

    return (
        <div className={styles.thumbnailPanel}>
            <div className={styles.thumbnailPanelContent}>
                <Button 
                    rounded 
                    onClick={onClose} 
                    className={styles.closeButton}>
                    <FontAwesomeIcon icon={faTimes} />
                </Button>
                <div className={styles.thumbnailContainer}>
                    {Object.values(connections).map((connection) => (
                        <div key={connection.id} className={styles.thumbnailWrapper}>
                            <div 
                                className={styles.thumbnail}
                                style={{
                                    backgroundColor: connection.color
                                }}
                            >
                                <div 
                                    ref={(el) => thumbnailRefs.current[connection.id] = el}
                                    className={styles.videoContainer}
                                    id={`thumbnail-${connection.id}`}
                                />
                                <div className={styles.userInfo}>
                                    <span>{connection.userAlias}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
} 